import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import createThemedComponent from '../../../theming/utils/createThemedComponent';
import IconButton from '../IconButton';
import { Facebook, Instagram, Pinterest, Twitter, Medium, Shop } from './SocialPageButton.styles';
export var BUTTON_TYPE = {
  facebook: {
    image: /*#__PURE__*/React.createElement(Facebook, null)
  },
  instagram: {
    image: /*#__PURE__*/React.createElement(Instagram, null)
  },
  pinterest: {
    image: /*#__PURE__*/React.createElement(Pinterest, null)
  },
  twitter: {
    image: /*#__PURE__*/React.createElement(Twitter, null)
  },
  medium: {
    image: /*#__PURE__*/React.createElement(Medium, null)
  },
  shop: {
    image: /*#__PURE__*/React.createElement(Shop, null)
  }
};
/**
 *
 * Themeable SocialPageButton component which is meant to link to a product's social media pages.
 *
 * Allows for `facebook`, `instagram`, `pinterest`, `twitter`, `medium` & `shop` types.
 *
 * **Default Styles**
 *
 * To view the `SocialPageButton` styling directly, see [SocialPageButton.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/widgets/SocialPageButton/SocialPageButton.styles.js)
 *
 * ## Example Usage
 * ```js
 * import { SocialPageButton } from '@minerva-analytics/pantheon';
 *
 * <SocialPageButton
 *   type="facebook"
 *   href="https://www.facebook.com"
 * />
 * ```
 */

export var SocialPageButtonComponent = function SocialPageButtonComponent(_ref) {
  var type = _ref.type,
      href = _ref.href,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "href"]);

  return /*#__PURE__*/React.createElement(IconButton, _extends({
    href: href,
    target: "_blank"
  }, rest), BUTTON_TYPE[type].image);
};
SocialPageButtonComponent.propTypes = {
  /** Type of button (facebook, instagram, pinterest, twitter, medium) */
  type: PropTypes.string,

  /** Link that button should go to */
  href: PropTypes.string
};
var SocialPageButton = createThemedComponent('SocialPageButton', SocialPageButtonComponent);
export default SocialPageButton;